// 从cookie中获取值
export function getCookie(name) {
  let type=1;
  let cookieValue = null;
  if(type==1){
      if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();
          if (cookie.substring(0, name.length + 1) === (name + '=')) {
            cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
            break;
          }
        }
      }
  }
  else{
    // let cookieValue = null;
     cookieValue = document.querySelector('[name=csrfmiddlewaretoken]').value;
  }
  return cookieValue;
}

// 在 main.js 或 axios 配置文件中
import axios from 'axios';

// 设置 axios 默认配置
axios.defaults.withCredentials = true;

// 请求拦截器
axios.interceptors.request.use(
  function(config) {
    // 使用外部定义的 getCookie 函数
    const csrftoken = getCookie('csrftoken');
    if (csrftoken && ['post', 'put', 'patch', 'delete'].includes(config.method.toLowerCase())) {
      config.headers['X-Csrftoken'] = csrftoken;
      // console.log('设置 CSRF Token:', csrftoken); // 调试
    }
    
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

